export const PREFETCH_SUCCESS = 'PREFETCH/SUCCESS';
export const PREFETCH_FAILURE = 'PREFETCH/FAILURE';
export const prefetchSuccess = payload => ({
  type: PREFETCH_SUCCESS,
  payload
});
export const prefetchFailure = payload => ({
  type: PREFETCH_FAILURE,
  payload
});